import React from 'react'
import {useList} from '@pankod/refine-core';
import { Typography, Box, Stack, Link, color } from '@pankod/refine-mui';
import { useGetIdentity } from '@pankod/refine-core';

import { ChevronRightRounded } from '@mui/icons-material';

import { PieChart, PropertyReferrals, TotalRevenue, PropertyCard, TopAgent } from 'components';

const Home = () => {
  const { data: user } = useGetIdentity();
  const {data, isLoading, isError} = useList({
    resource: 'properties',
    config:{
      pagination:{
        pageSize:4,
      }
    }
  })
  
  const latestProperties = data?.data ?? [];

  if(isLoading) return <Typography>Loading...</Typography>
  if(isError) return <Typography>Something went wrong!</Typography>



  return (
    <Box>
      <Typography fontSize={28} fontWeight={800} color="#11142D">
        Dashboard
      </Typography>
      {user?.name ? (
        <Typography variant="subtitle2" mt="-2px">Welcome back, {user?.name}!</Typography>
      ) : null}

      <Box mt="25px" display="flex" flexWrap="wrap" gap={2}>
        <PieChart
          title="Properties for Sale"
          value={684}
          series={[75,25]}
          colors={['#e67e22','#e4e8ef']}
          increase={8}
        />
        <PieChart
          title="Properties for Rent"
          value={550}
          series={[60,40]}
          colors={['#c0392b','#e4e8ef']}
          increase={14}
        />
        <PieChart
          title="Total customers"
          value={5684}
          series={[75,25]}
          colors={['#8e44ad','#e4e8ef']}
          increase={10}
        />
        <PieChart
          title="Properties for Cities"
          value={555}
          series={[75,25]}
          colors={['#27ae60','#e4e8ef']}
          increase={6}
        />
      </Box>

      <Stack mt="16px" width="100%" direction={{xs: 'column', lg: 'row'}} gap={2}>
        <TotalRevenue/>
        <PropertyReferrals/>
      </Stack>

      <Box
        flex={1}
        borderRadius="15px"
        padding="32px"
        bgcolor="#fcfcfc"
        display="flex"
        flexDirection="column"
        minWidth="100%"
        mt="16px"
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography fontSize="18px" fontWeight={600}
        color="#11142d">Latest Properties</Typography>
        
          <Link color="#808191" fontSize="16px" href='/properties' sx={{'&:hover': {color: "#000"}}}  >View All </Link>
          
       
        
        </Stack>
        

        <Box mt={1} sx={{display:'flex', flexWrap: 'wrap', gap: 4}}>
          {latestProperties.map((property) =>(
            <PropertyCard
              key={property._id}
              id={property._id}
              title={property.title}
              location={property.location}
              price={property.price}
              photo={property.photo}
            />
          ))}
        </Box>
      </Box>

    </Box>
  )
}

export default Home